<template>
  <div class="chatResponse">
    <transition name="fade-in">
      <div class="messageTip messageTip__him" v-if="question">
        <div class="message">{{ question | urlify }}</div>
      </div>
    </transition>
    <transition name="fade-in">
      <div class="messageTip messageTip__own" v-if="answer">
        <div class="message" v-html="$options.filters.urlify(answer)"></div>
      </div>
  </transition>
</div></template>

<script>
import { mapGetters } from 'vuex'
import urlify from '../../filters/urlify'
export default {
  name: 'MessageTip',
  computed: {
    ...mapGetters({
      getConversationState: 'messages/getConversationState',
      personType: 'messages/getPersonType'
    })
  },
  methods: {
    onPersonTypeChange (event) {
      this.$emit('personTypeChange', event.target.value)
    }
  },
  props: {
    question: {
      required: true,
      type: String
    },
    answer: {
      type: String
    },
    index: {
      type: Number
    }
  },
  filters: {
    urlify
  }
}
</script>

<style lang="scss">
.messageTip {
  margin: 0 0 15px 0;
  display: flex;

  .message {
    padding: 6px 10px;
    max-width: calc(100% - 15px);
    border-radius: 0 6px 6px 6px;
    color: #2C2C2E;
    background: #F2F2F7;
    position: relative;
    font-size: 12px;
    line-height: 18px;
    margin-left: 8.72px;

    &:before {
      content: '';
      position: absolute;
      width: 8.72px;
      height: 11.12px;
      left: -8px;
      top: 0;
      clip-path: polygon(0 0, 100% 100%, 100% 0);
      background: #F2F2F7;
    }
  }
  a {
    color: #20653F;
    text-decoration: none;
    overflow-wrap: break-word;
    border-bottom: 1px solid #20653F;
    &:hover {
      border-bottom: 0;
    }
  }
  &__him {
    flex-direction: row-reverse;

    .message {
      border-radius: 6px 0 6px 6px;
      background: #20653F;
      color: #fff;
      margin-right: 8px;

      &:before {
        display: none;
      }

      &:after {
        content: '';

        position: absolute;
        width: 8.72px;
        height: 11.12px;
        right: -8.72px;
        top: 0;
        clip-path: polygon(0 0, 0 100%, 100% 0);
        background: #20653F;
      }
    }
  }
}

.fade-in-enter-active {
  transition: all 0.3s ease;
}

.fade-in-leave-active {
  transition: all 0.3s ease;
}

.fade-in-enter, .fade-in-leave-to {
  opacity: 0;
}

*,
*:after,
*:before {
  box-sizing: border-box;
}

form {
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
}

label {
    display: flex;
    cursor: pointer;
    font-weight: 500;
    position: relative;
    overflow: hidden;
    margin-bottom: 0.375em;
input {
      position: absolute;
      left: -9999px;
      &:checked + span {
        background-color: mix(#fff, #00005c, 84%);
        &:before {
          box-shadow: inset 0 0 0 0.4375em #00005c;
        }
      }
    }
  span {
      display: flex;
      align-items: center;
      padding: 0.375em 0.75em 0.375em 0.375em;
      border-radius: 99em; // or something higher...
      transition: 0.25s ease;
      &:hover {
        background-color: mix(#fff, #00005c, 84%);
      }
      &:before {
        display: flex;
        flex-shrink: 0;
        content: "";
        background-color: #fff;
        width: 1.5em;
        height: 1.5em;
        border-radius: 50%;
        margin-right: 0.375em;
        transition: 0.25s ease;
        box-shadow: inset 0 0 0 0.125em #00005c;
      }
    }
}
</style>
